import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ur24ckegrz: FaireBrandEntity = {
  token: "b_ur24ckegrz",
  type: "brand",
  name: "Evileyefavor",
  avatarUrl:
    "https://cdn.faire.com/fastly/ae867e4bccde1120bf70765b96b2e486be21ba88fb589cba878f66a8d2225e4f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c26ebdb3b8c58446af4fd6acb099253ce9e587ec61119079b29eab7f219ed081.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ae867e4bccde1120bf70765b96b2e486be21ba88fb589cba878f66a8d2225e4f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c26ebdb3b8c58446af4fd6acb099253ce9e587ec61119079b29eab7f219ed081.jpeg",
  location: "North Providence, RI, USA",
  minimumOrderDollars: 97,
  rating: 4.8,
  reviewCount: 149,
  isInsider: true,
  description:
    "“EvilEyeFavor” is an handmade shop of home decors & accessories made with high-quality materials.\n All our production is in istanbul - Turkiye and we deliver worldwide with express shipping services. \nDesigning home decors & accessories based on Evil Eye started as a hobby while studying Architecture, then it became a passion and a full-time job. My website allows me to continue my creative life on a platform that I enjoy every process, begins by discovering mystery of Evil Eye and designing unique products for our precious customers. Since childhood, I’ve been surrounded by creativity. I was inspired by my father’s genius projects and mother’s designing & paintings around the home. While my mother designing precious figures with evil eyes, my father produces them accordingly.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:51.135Z",
    importedBy: "entity-db-cli",
  },
};
